var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._v(
      " " +
        _vm._s(
          _vm.$vuetify.lang.t(
            "$vuetify.COURSE.BASE_PDF_QUESTION_RENDERRE.LABEL_ANSWER_THE_QUESTION"
          )
        ) +
        ": "
    ),
    !_vm.submission.isQuestionPaper
      ? _c("span", [
          _vm._v(" " + _vm._s(_vm.studentAnswer) + " "),
          _vm.studentAnswer && !_vm.submission.isStudentWork
            ? _c("span", { staticClass: "ml-1" }, [
                _c("span", {
                  style: {
                    color: _vm.isCorrect ? "#4bca81" : "#d4504c",
                    fontWeight: "bold",
                    fontSize: "14px",
                  },
                  domProps: {
                    innerHTML: _vm._s(_vm.isCorrect ? "&#10003;" : "&#x2715;"),
                  },
                }),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }